import { createContext } from 'react';
import { ILayoutContext } from '@/context/LegacyLayoutContext';
import { organizationConfig } from '@/context/AdminLayoutContext';

const layoutContext = createContext<ILayoutContext>({
  siderWidth: 200,
  layoutConfig: organizationConfig['ARYA'],
});

export default layoutContext;
